//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/DesignSimulation.js";
import "../no/NXObject.js";
import "../no/ugmath.js";
let d=[[],[[["resultType"],"HasResults",{R_:{hasResults:''}},1,0],[["resultType","index"],"GetScalarResultAt",{R_:{value:''}},2,0],[["resultType","nVertices"],"GetAllScalarResults",{R_:{values:""}},1,0],[["resultType","index"],"GetVectorResultAt",{R_:{value:''}},2,0],[["resultType","nVertices"],"GetAllVectorResults",{R_:{values:""}},1,0],[["resultType","maxMagnitude"],"GetMaxMagnitudeAndLocation",{R_:{maxMagnitudePosition:''}},1,0]],[]];
SPLM.DesignSimulation.AnalysisBodySubcaseResults = class extends SPLM.NXObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.DesignSimulation.AnalysisBodySubcaseResults";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.DesignSimulation.AnalysisBodySubcaseResults.ResultType = Object.freeze({
    "Displacement" : "Displacement", "StressVonMises" : "StressVonMises", "StressWorstPrincipal" : "StressWorstPrincipal"});

export default SPLM;